import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { ApiService, BookingAssistantResponse } from 'src/app/services/api.service';
import { formatDate } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-slot-selection',
  templateUrl: './slot-selection.component.html',
  styleUrls: ['./slot-selection.component.scss']
})
export class SlotSelectionComponent implements OnInit, OnChanges {
  

  @Input() datesToHighlight: any[] = [];
  @Input() slots: any = [];
  @Input() slotCheckCount: any;
  @Input() countryId: any;
  @Input() isChild = false;
  @Input() bookingData: any;
  @Input() doctorId: any;
  @Input() doctorBranchId: any;
  @Input() patientId: any;
  @Input() isRevisit: any;
  @Input() isLoading = false;
  // @Output() stepperNextEvent = new EventEmitter<any>();
  @Output() stepperNextEvent = new EventEmitter<{ slot: any, slotPriceDetails: any }>();
  // @Output() slotPriceDetailsEmitter = new EventEmitter<any>();
  @ViewChild('myCalendar') myCalendar: any;
  selected: any;
  activeDate: any;
  startDate: any;
  isSlotsAvailable = true;
  isSlotsLoaded = true;
  loaderSlots = [1, 2, 3, 4, 5];
  slotPriceDetails: any;
  assistantMessage = '';
  assistantLoading = false;
  assistantReply = '';
  assistantError = '';
  assistantMissingInformation: string[] = [];
  assistantSuggestedSlotId: number | null = null;
  suggestedSlot: any = null;
  quickSuggestions = [
    { label: 'Tomorrow morning', query: 'Tomorrow morning', icon: '🌅' },
    { label: 'Tomorrow afternoon', query: 'Tomorrow afternoon', icon: '☀️' },
    { label: 'Earliest slot', query: 'Earliest available appointment', icon: '⚡' },
    { label: 'This weekend', query: 'This weekend', icon: '🗓️' }
  ];

  constructor(private http: HttpClient, private apiService: ApiService, private renderer: Renderer2, private authService: AuthService, private storage: StorageService) {
    
    this.apiService.isSlotsLoaded.subscribe((data: any) => {
      this.isSlotsLoaded = data;
    });
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    const date = cellDate;
    const highlightDate = this.datesToHighlight
      .map((strDate: any) => new Date(strDate))
      .some((d: any) => d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear());

    return highlightDate ? 'special-date' : '';
  };


  async onSelected(date: any) {
    let formattedDate = formatDate(date, 'yyyy-MM-dd', 'en-US', '+0530');
    this.getSlots(formattedDate);
  }

  getSlots(date: any) {
    this.apiService.isSlotsLoaded.next(false);
    this.apiService.getSlotsByDate(date, this.isChild, this.doctorId, this.doctorBranchId, this.patientId, this.isRevisit).subscribe({
      next: (data: any) => {
        if (data.success === true) {
          //sorting by date and filtering by booking start and booking end date
          let currentDate = new Date();
          this.slotPriceDetails = data.booking_charge;
          
          // Emit slotPriceDetails to the parent component
          // this.slotPriceDetailsEmitter.emit(this.slotPriceDetails);
          let slotData = data["data"].sort((firstEl: any, secondEl: any) => Date.parse(firstEl.start_time) - Date.parse(secondEl.start_time)).filter(
            (element: any) => currentDate >= new Date(element.time_limits.booking_start_time) && currentDate <= new Date(element.time_limits.booking_end_time)
          );
          slotData.forEach((element: any, index: number) => {
            if (this.slotCheckCount <= +element.available_slot_count) {
              slotData[index].slotsLimited = false;
            } else {
              slotData[index].slotsLimited = true;
            }
          });
          this.apiService.slots.next(slotData);
          this.apiService.slots.subscribe((data: any) => {
            this.slots = data;
            this.suggestedSlot = this.findSuggestedSlot(this.assistantSuggestedSlotId);
            if (this.slots.length > 0) {
              this.isSlotsAvailable = true;
            } else {
              this.isSlotsAvailable = false;
            }
            return this.slots;
          });
        } else {
          this.apiService.slots.next([]);
          this.isSlotsAvailable = false;
        }
      },

      error: (err: any) => {
        this.isSlotsAvailable = false;
        this.apiService.slots.next([]);
        this.apiService.isSlotsLoaded.next(true);
      },
      complete: () => {
        this.apiService.isSlotsLoaded.next(true);
      }
    });

  }

  askBookingAssistant(): void {
    const message = this.assistantMessage.trim();
    if (!message || this.assistantLoading) {
      return;
    }

    this.assistantLoading = true;
    this.assistantError = '';
    this.assistantReply = '';
    this.assistantMissingInformation = [];
    this.assistantSuggestedSlotId = null;
    this.suggestedSlot = null;

    this.apiService.bookingAssistant(message).subscribe({
      next: (response: BookingAssistantResponse) => {
        this.assistantLoading = false;
        if (!response.success || !response.data) {
          this.assistantError = response.message || 'The assistant could not find a suitable appointment.';
          return;
        }

        this.assistantReply = response.data.reply;
        this.assistantMissingInformation = response.data.missing_information || [];
        this.assistantSuggestedSlotId = response.data.slot_id;
        this.suggestedSlot = this.findSuggestedSlot(response.data.slot_id);
      },
      error: (error: any) => {
        this.assistantLoading = false;
        this.assistantError = error?.error?.message || 'The booking assistant is temporarily unavailable.';
      }
    });
  }

  chooseSuggestedSlot(): void {
    if (this.suggestedSlot) {
      this.slotRegistration(this.suggestedSlot);
    }
  }

  applyQuickPrompt(promptText: string): void {
    this.assistantMessage = promptText;
    this.askBookingAssistant();
  }

  clearAssistantMessage(): void {
    this.assistantMessage = '';
  }

  private findSuggestedSlot(slotId: number | null): any {
    if (!slotId || !this.slots) {
      return null;
    }

    return this.slots.find((slot: any) =>
      Number(slot.id) === Number(slotId) &&
      !slot.blocked && !slot.is_break && !slot.slotsLimited
    ) || null;
  }

  monthSelected(event: any) {
    const monthCount = event.getMonth() + 1;
    this.getMonthSlots(monthCount);
  }

  getMonthSlots(month: any) {
    this.apiService.getMonthSlots(month, this.isChild, this.doctorId, this.doctorBranchId).then((data: any) => {
      if (data.success == true) {
        this.apiService.monthSlots.next(data["data"].date);
        this.apiService.monthSlots.subscribe((data: any) => {
          this.datesToHighlight = data;
          this.myCalendar.updateTodaysDate();          
        });
      }else {
      }
    },
    (error) => {
    }
  );
  }

  slotRegistration(slot: any) {
    this.stepperNextEvent.emit({ slot, slotPriceDetails: this.slotPriceDetails });
  }



  ngAfterViewInit() {
    const monthPrevBtn = document.querySelectorAll(
      '.mat-calendar-previous-button'
    );
    const monthNextBtn = document.querySelectorAll('.mat-calendar-next-button');

    if (monthPrevBtn) {
      Array.from(monthPrevBtn).forEach((button) => {
        this.renderer.listen(button, 'click', (event) => {
          this.selected = "";
          //handle month change
          const monthCount = this.myCalendar.activeDate.getMonth() + 1;
          this.getMonthSlots(monthCount);
        });
      });
    }

    if (monthNextBtn) {
      Array.from(monthNextBtn).forEach((button) => {
        this.renderer.listen(button, 'click', (event) => {
          this.selected = "";
          //handle month change
          const monthCount = this.myCalendar.activeDate.getMonth() + 1;
          this.getMonthSlots(monthCount);
        });
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['datesToHighlight'] && this.datesToHighlight.length > 0) {
      this.startDate = new Date(this.datesToHighlight[0]);
      this.selected = this.startDate;
    }
  }

  ngOnInit(): void {
    if (this.datesToHighlight.length > 0) {
      this.startDate = new Date(this.datesToHighlight[0]);
      this.selected = this.startDate;
    }
  }

}
